import { createFileRoute } from '@tanstack/react-router';
import { AdminFeatureFlagsView } from '@/components/admin/AdminFeatureFlagsView';

interface FeatureFlagsSearch {
  readonly tab?: 'launched';
}

export const Route = createFileRoute('/_authed/admin/feature-flags/')({
  // A rejected key is returned as explicit `undefined`: the router merges this
  // result over the raw URL search, so an omitted key would let the raw value
  // through to `useSearch()`.
  validateSearch: (raw: Record<string, unknown>): FeatureFlagsSearch => ({
    tab: raw.tab === 'launched' ? 'launched' : undefined,
  }),
  component: AdminFeatureFlagsPage,
});

function AdminFeatureFlagsPage() {
  const { tab } = Route.useSearch();
  return <AdminFeatureFlagsView tab={tab ?? 'rolling-out'} />;
}
